var _createClass = require("/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/createClass.js");
var _classCallCheck = require("/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/classCallCheck.js");
var _inherits = require("/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/inherits.js");
var _possibleConstructorReturn = require("/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/getPrototypeOf.js");
var _wrapNativeSuper = require("/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/wrapNativeSuper.js");
require("core-js/modules/es6.function.name.js");
require("core-js/modules/es6.reflect.construct.js");
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var SampleValidationError = /*#__PURE__*/function (_Error) {
  "use strict";

  _inherits(SampleValidationError, _Error);
  var _super = _createSuper(SampleValidationError);
  function SampleValidationError(error) {
    var _this;
    _classCallCheck(this, SampleValidationError);
    _this = _super.call(this, error);
    _this.name = 'SampleValidationError';
    _this.error = error;
    return _this;
  }
  return _createClass(SampleValidationError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
module.exports = SampleValidationError;